import React, { createContext, useContext } from 'react';
import { responsive } from '@alucio/lux-ui';
import omit from 'lodash/omit';
import { useState } from 'react';
import { useEffect } from 'react';
import { useVideoContext } from '@alucio/video';
export var MeetingControlSelectedVideoDimensionEnum;
(function (MeetingControlSelectedVideoDimensionEnum) {
    MeetingControlSelectedVideoDimensionEnum["HIDE"] = "HIDE";
    MeetingControlSelectedVideoDimensionEnum["SMALL"] = "SMALL";
    MeetingControlSelectedVideoDimensionEnum["STANDARD"] = "STANDARD";
})(MeetingControlSelectedVideoDimensionEnum || (MeetingControlSelectedVideoDimensionEnum = {}));
export var SelectedRightSideBarComponentEnum;
(function (SelectedRightSideBarComponentEnum) {
    SelectedRightSideBarComponentEnum[SelectedRightSideBarComponentEnum["NOTES"] = 0] = "NOTES";
    SelectedRightSideBarComponentEnum[SelectedRightSideBarComponentEnum["CHAT"] = 1] = "CHAT";
})(SelectedRightSideBarComponentEnum || (SelectedRightSideBarComponentEnum = {}));
const MeetingsControlsContext = createContext(null);
const standardSize = { container: { width: 208, height: 120 }, nameContainer: { width: 176 } };
const smallSize = { container: { width: 208 / 1.5, height: 120 / 1.5 }, nameContainer: { width: 205 / 2.8 } };
export const MeetingControlsContext = (props) => {
    const { children, setIsFullScreen, isFullScreen } = props;
    const isSmallScreenSize = responsive.dimensions.screenWidth < 1280;
    const [toggleSlides, setToggleSlides] = useState(isSmallScreenSize);
    const [isRightSideBarVisible, setRightSideBarVisible] = useState(false);
    const [currentVideoDimension, setCurrentVideoDimension] = useState(MeetingControlSelectedVideoDimensionEnum.STANDARD);
    const [selectedSideBarComponent, setSelectedSideBarComponent] = useState(SelectedRightSideBarComponentEnum.NOTES);
    const [videoSize, setCurrentVideoSize] = useState(standardSize);
    const { unreadMsgCount, setUnreadMsgCount } = useVideoContext();
    const [visibleRightBarComponents, setVisibleRightBarComponents] = useState([
        SelectedRightSideBarComponentEnum.CHAT
    ]);
    useEffect(() => {
        if (selectedSideBarComponent === SelectedRightSideBarComponentEnum.CHAT) {
            setUnreadMsgCount(0);
        }
    }, [selectedSideBarComponent, unreadMsgCount]);
    const values = omit(props, 'children');
    const toggleSlidesHandler = () => setToggleSlides((p) => !p);
    const toggleRightBarHandler = (component) => setRightSideBarVisible((p) => {
        if (visibleRightBarComponents.length === 1 && p) {
            setSelectedSideBarComponent(undefined);
        }
        return !p;
    });
    const setCurrentVideoDimensionsHandler = (videoDimension) => {
        setCurrentVideoDimension(videoDimension);
        if (videoDimension === MeetingControlSelectedVideoDimensionEnum.STANDARD) {
            setCurrentVideoSize(standardSize);
        }
        if (videoDimension === MeetingControlSelectedVideoDimensionEnum.SMALL) {
            setCurrentVideoSize(smallSize);
        }
    };
    const selectTabOption = (option) => {
        setSelectedSideBarComponent(option);
    };
    const visibleRightBarComponentsHandler = (options) => {
        setVisibleRightBarComponents(options);
    };
    const contextValues = Object.assign(values, {
        toggleSlides,
        toggleSlidesHandler,
        currentVideoDimension,
        setCurrentVideoDimensionsHandler,
        selectedSideBarComponent,
        selectTabOption,
        setRightSideBarVisible,
        visibleRightBarComponentsHandler,
        isRightSideBarVisible,
        videoSize,
        toggleRightBarHandler,
    });
    return (React.createElement(MeetingsControlsContext.Provider, { value: contextValues }, children));
};
export const useMeetingControls = () => useContext(MeetingsControlsContext);
//# sourceMappingURL=useMeetingControl.js.map